import { render } from "./Hall4En.vue?vue&type=template&id=6cd99190"
import script from "./Hall4En.vue?vue&type=script&lang=js"
export * from "./Hall4En.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__